import {ComponentType} from "react";
import {RouteNames} from "./routeNames";
import Login from "../pages/auth/Login";
import ForgetPassword from "../pages/auth/ForgetPassword";
import Registration from "../pages/auth/Registration";
import Page404 from "../pages/404";
import Main from "../pages/main";
import Archive from "../pages/archive";
import City from '../pages/location/city';
import Country from '../pages/location/country';
import ResetPassword from "../pages/auth/ResetPassword";


export interface IRoute {
    path: string;
    element: ComponentType;
    exact?: boolean;
}
export interface IRoutes extends IRoute {
    children?: IRoute[],
}

export const publicRoutes: IRoutes[] = [
    { path: RouteNames.LOGIN, element: Login },
    { path: RouteNames.REGISTRATION, element: Registration },
    { path: RouteNames.FORGET_PASSWORD, element: ForgetPassword },
    { path: RouteNames.NOT_FOUND, element: Login },
    { path: RouteNames.RESET_PASSWORD, element: ResetPassword },
]
export const privateRoutes: IRoutes[] = [
    { path: RouteNames.MAIN, element: Main },
    { path: RouteNames.ARCHIVE, element: Archive },
    { path: RouteNames.CITY, element: City },
    { path: RouteNames.COUNTRY, element: Country },
    { path: RouteNames.NOT_FOUND, element: Page404 },
]
